<div class="portfolio-container">
    <h1>Freelancing / Consulting Highlights</h1>
    <p>I love to engineer things and here is the work I'm most proud of.</p>
    <div class="portfolio-item-list">
        <div *ngFor="let item of items" >
            <app-portfolio-item [item]="item"></app-portfolio-item>
        </div>
    </div>
</div>